import { ThemeOptions } from "@mui/material";
import { createTheme } from "@mui/material/styles";

export const ticketEasyColors = {
    psnBlue: '#162346',
    psnGreen: '#62BCBD',
    psnBackground: '#F4F6F8',
    psnAlert: '#cc5500',
    psnAccent: '#337ab7'
};

export const ticketEasyTheme = createTheme({
    palette: {
        primary: {
            main: ticketEasyColors.psnBlue,
        },
        secondary: {
            main: ticketEasyColors.psnGreen,
        },
        background: {
            default: ticketEasyColors.psnBackground,
            paper: '#FFFFFF',
        },
        error: {
            main: ticketEasyColors.psnAlert,
        },
        info: {
            main: ticketEasyColors.psnAccent,
        },
        text: {
            primary: ticketEasyColors.psnBlue,
            secondary: '#666666',
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    width: '100%',
                    maxWidth: '1200px',
                    margin: '0 auto',
                    padding: '0 16px',
                    boxSizing: 'border-box',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
                InputLabelProps: {
                    shrink: true
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 500,
                },
                contained: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0px 5px 10px #888888',
                    borderRadius: '5pt',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                },
            },
        },
    },
    typography: {
        fontFamily: "'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        h1: { color: ticketEasyColors.psnBlue },
        h2: { color: ticketEasyColors.psnBlue },
        h3: { color: ticketEasyColors.psnBlue },
        h4: { color: ticketEasyColors.psnBlue },
        h5: { color: ticketEasyColors.psnBlue },
        h6: { color: ticketEasyColors.psnBlue },
    },
});